import { createAsyncThunk } from '@reduxjs/toolkit';

import { type TJsonQuery, getOfferTypeFromJsonQuery, isSuburban } from '@/packages/JsonQuery';

import { MOSCOW_AND_REGION, SPB_AND_REGION } from '@/microfrontends/filters/shared/constants/regions';
import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { applyLocation } from '@/microfrontends/filters/shared/store/thunks/geo/applyLocation';
import { selectGeoAction } from '@/microfrontends/filters/shared/store/thunks/geo/selectGeoAction';
import { type TGeoObject } from '@/microfrontends/filters/shared/types/LEGACY/geoSuggest';
import { type TLocation } from '@/microfrontends/filters/shared/types/location';

export const selectGeo = createAsyncThunk<TJsonQuery, TGeoObject, TThunkApi>(
  'geo/selectGeo',
  async (geoObject, thunkApi) => {
    const { locationInfo } = geoObject;
    const { dispatch, getState } = thunkApi;

    const state = getState();

    if (locationInfo) {
      await dispatch(applyLocation(locationInfo));
    } else {
      const location =
        state.regions.find(r => r.id === geoObject.id) || state.regions.find(r => r.id === geoObject.regionId);

      let extendedLocation: TLocation | undefined = location;
      const offerType = getOfferTypeFromJsonQuery(state.jsonQuery.current);

      if (isSuburban(offerType) && location) {
        switch (true) {
          case MOSCOW_AND_REGION.includes(location.id):
            extendedLocation = 'moscow_mo';
            break;
          case SPB_AND_REGION.includes(location.id):
            extendedLocation = 'spb_lo';
            break;
        }
      }

      await dispatch(applyLocation(extendedLocation));
    }

    await dispatch(selectGeoAction({ geoObject, location: state.location.data }));

    return getState().jsonQuery.current;
  },
);
